import { ChevronDown } from '@squareup/dex-icons/dex/control';
import { ReferenceExampleScenario } from '@squareup/dex-types-oas';
import {
  NativeDropdown,
  NativeDropdownRow,
  nativeDropdownRowStyles,
} from '@squareup/dex-ui';
import { Paragraph10 } from '@squareup/dex-ui-shared-base';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

interface ReferenceCodeExampleSwitcherProps {
  selected: ReferenceExampleScenario;
  scenarios: ReferenceExampleScenario[];
  onScenarioChanged: (scenario: ReferenceExampleScenario) => void;
}

const ReferenceCodeExampleSwitcher: FunctionComponent<
  ReferenceCodeExampleSwitcherProps
> = ({ selected, scenarios, onScenarioChanged }) => {
  return (
    <NativeDropdown
      trackingId="reference-code-example-list"
      selected={selected.name}
      trigger={
        <>
          <Paragraph10>Example:&nbsp;</Paragraph10>
          <Paragraph10 weight="semi-bold" margin={{ right: '0.5x' }}>
            {selected.name}
          </Paragraph10>
          <ChevronDown className={clsx(commonIconStyles['icon-color'])} />
        </>
      }
    >
      {scenarios.map((scenario) => {
        return (
          <NativeDropdownRow
            trackingId={`reference-code-example-${scenario.name}`}
            key={scenario.name}
            value={scenario.name}
            onSelected={() => onScenarioChanged(scenario)}
          >
            <Paragraph10
              weight="semi-bold"
              className={nativeDropdownRowStyles.primary}
            >
              {scenario.name}
            </Paragraph10>
          </NativeDropdownRow>
        );
      })}
    </NativeDropdown>
  );
};

export { ReferenceCodeExampleSwitcher };
